import type * as lazyIndex from "./lazyIndex";
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from "owa-bundling";
import type { TeamsConversationProps } from "./components/TeamsConversation";

export type { TeamsConfigurationOverrides } from "./types/TeamsChatApi";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaTeamsEmbedClient" */ "./lazyIndex"), { name: "OwaTeamsEmbedClient" });

export const LazyTeamsChatList: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.TeamsChatList);

export const LazyTeamsConversation: LazyComponent<TeamsConversationProps, unknown, void> = createLazyComponent(lazyModule, m => m.TeamsConversation);

export const lazyPrewarmTeamsClient: LazyAction<typeof lazyIndex.prewarmTeamsClient, typeof lazyModule> = new LazyAction(lazyModule, m => m.prewarmTeamsClient);
